import { Box } from '@mui/material';

import { LoadingSpinner } from '@/components/common/LoadingSpinner';

/** The `<Suspense>` fallback for every lazy-loaded route chunk (§10.1). */
export function LoadingLayout() {
  return (
    <Box
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}
    >
      <LoadingSpinner label="Loading Willnq…" />
    </Box>
  );
}
